import { FiX } from 'react-icons/fi';
import type { ActiveFilter } from './filterTypes';

interface ActiveFilterChipsProps {
    filters: ActiveFilter[];
    onRemove: (id: string) => void;
    onClearAll: () => void;
}

// Barra de chips dos filtros ativos, acima da grid. Cada chip mostra "Rótulo: valor" e um ×
// que remove só aquele filtro; "Limpar tudo" zera todos. Fica oculta quando não há filtro
// ativo — assim "um milhão de filtros" possíveis não ocupam espaço até serem usados.
const ActiveFilterChips = ({ filters, onRemove, onClearAll }: ActiveFilterChipsProps) => {
    if (filters.length === 0) return null;

    return (
        <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-b border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-900">
            {filters.map((f) => (
                <span
                    key={f.id}
                    className="inline-flex items-center gap-1 pl-2.5 pr-1 py-1 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300"
                >
                    <span>{f.label}: {f.displayValue}</span>
                    <button
                        type="button"
                        onClick={() => onRemove(f.id)}
                        aria-label={`Remover filtro ${f.label}`}
                        className="p-0.5 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors"
                    >
                        <FiX size={12} />
                    </button>
                </span>
            ))}
            <button
                type="button"
                onClick={onClearAll}
                className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 underline ml-1"
            >
                Limpar tudo
            </button>
        </div>
    );
};

export default ActiveFilterChips;
